import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Grid,
  MenuItem,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import * as React from "react";
import dashboardStyles from "./dashboardStyles.module.css";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import { AUDIT_NEW_FARMER_CREATE, POST_AUDIT_REMARK } from "../../constants";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useEffect } from "react";

function NewUserAuditFormComponent({
  setOpenSnackbar,
  setSeverity,
  setMessage,
  setalertTitle,
  FormMobileNo,
  typeOfUser,
  setFormOpen,
  auditMobNum,
  auditLotNum,
  auditName,
  auditZone,
  setAuditLotNum,
  setAuditName,
  setAuditZone,
  callID,
  callType,
}) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));

  const [userType, setUserType] = useState("");
  const [type, setType] = useState(""); // 'new' by default
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [isNeworOld, setIsNewOrOld] = useState("");

  const [lotNumber, setLotNumber] = useState("");
  const [farmer_name, setFarmer_Name] = useState("");
  const [mobNo, setMobNo] = useState("");
  const [Zone_Name, setZone_Name] = useState("");
  const [branch_Name, setBranch_Name] = useState("");
  const [first_Week_M, setFirst_Week_M] = useState("");
  const [Total_Mortality, setTotal_Mortality] = useState("");
  const [Avg_Lift_Wt, setAvg_Lift_Wt] = useState("");
  const [ABWT, setABWT] = useState("");
  const [follow_up_date, setFollow_Up_Date] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [shedFeild, setShedFeild] = useState("");
  const [Shed_Type, setShed_Type] = useState("");
  const [previousPoultryExperience, setPreviousPoultryExperience] =
    useState("");
  const [previousCompanyName, setPreviousCompanyName] = useState("");
  const [status, setStatus] = useState("");
  const [followUpBy, setFollowUpBy] = useState("");
  const [chichHoused, setChickHoused] = useState("");
  const [meanAge, setMeanAge] = useState("");
  const [bodyWeight, setBodyWeight] = useState("");
  const [reason, setReason] = useState("");
  const [feed, setFeed] = useState("");
  const [medicine, setMedicine] = useState("");
  const [stock, setStock] = useState("");
  const [iiftIn, setIiftIn] = useState("");
  const [iiftOut, setIiftOut] = useState("");
  const [Ls_Visit, setLS_Visit] = useState("");
  const [Bm_Visit, setBM_Visit] = useState("");
  const [Daily_ent, setDaily_Ent] = useState("");
  const [FeedEnt, setFeedEnt] = useState("");
  const [mortality_ent, setMortality_Ent] = useState("");
  const [BWT_Ent, setBWT_Ent] = useState("");
  const [Medicine_ent, setMedicine_Ent] = useState("");

  useEffect(() => {
    setMobNo(auditMobNum);
    setIsNewOrOld(typeOfUser);
    setLotNumber(auditLotNum);
    setZone_Name(auditZone);
    setFarmer_Name(auditName);
  }, [auditMobNum, typeOfUser, auditLotNum, auditName, auditZone]);

  // Errors for validation
  const [errors, setErrors] = useState({});

  // Form validation
  const validateForm = () => {
    const newErrors = {};
    if (!farmer_name.trim()) newErrors.Farmer_Name = "Farmer Name is required";
    if (!mobNo.trim()) newErrors.Mobile = "Mobile Number is required";
    if (mobNo && mobNo.length !== 10)
      newErrors.Mobile = "Mobile Number must be 10 digits";
    if (!remarks.trim()) newErrors.remarks = "Remark is required";
    if (!status.trim()) newErrors.status = "Status is required.";
    if (status === "open") {
      if (!follow_up_date)
        newErrors.follow_up_date = "Follow-Up Date is required";
    }
    if (isNeworOld === "new") {
      if (!previousPoultryExperience.trim())
        newErrors.previousPoultryExperience = "Feild is required";
    }
    // Add additional field validations here...

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [loading, setLoading] = useState(false);

  // Handle form submission
  const handleSubmit = () => {
    if (validateForm()) {
      console.log("Form Submitted:", { userType, isNeworOld });

      const formData = {
        user_type: userType,
        type: isNeworOld,
        status: status,
        Lot_Number: lotNumber,
        farmer_name: farmer_name,
        branch_Name: branch_Name,
        Mobile: mobNo,
        Zone_Name: Zone_Name,
        Shed_Type: Shed_Type,
        previousPoultryExperience: previousPoultryExperience,
        previousCompanyName: previousCompanyName,
        first_Week_M: first_Week_M,
        Total_Mortality: Total_Mortality,
        Avg_Lift_Wt: Avg_Lift_Wt,
        ABWT: ABWT,
        AGE: meanAge,
        CH: chichHoused,
        BWT: bodyWeight,
        REASON: reason,
        FEED: feed,
        MED: medicine,
        STOCK: stock,
        IFFT_IN: iiftIn,
        IFFT_OUT: iiftOut,
        LS_VISIT: Ls_Visit,
        BM_VISIT: Bm_Visit,
        DAILY_ENT: Daily_ent,
        FEED_ENT: FeedEnt,
        MORT_ENT: mortality_ent,
        BWT_ENT: BWT_Ent,
        MED_ENT: Medicine_ent,
        follow_up_date: follow_up_date,
        followUpBy: followUpBy,
        REMARKS: remarks,
        AgentId: empDetails.EmployeeId,
        call_id: callID || "",
        call_type: callType || null,
      };

      setLoading(true);

      axios
        .post(POST_AUDIT_REMARK, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
        .then((response) => {
          console.log("here", response);

          setSeverity("success");
          setMessage(response.data.message);
          setOpenSnackbar(true);
          
          setFormOpen(false);
          setAuditLotNum("");
          setAuditName("");
          setAuditZone("");
        })
        .catch((error) => {
          console.log(error.response.data);

          setSeverity("error");
          setMessage(error.response.data.message);
          setOpenSnackbar(true);
        })
        .finally(() => {
          setLoading(false); // Reset loading to false once the API call completes
        });
    } else {
      alert("Please fix the errors before submitting.");
    }
  };

  return (
    <>
      {/* leadDetails Form */}

      <form>
        <Card sx={{ padding: "24px", borderRadius: "8px", boxShadow: 3 }}>
          <Box
            sx={{
              textAlign: "center",
              marginBottom: "40px",
              maxWidth: "800px",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "#333",
                marginBottom: "8px",
                textTransform: "uppercase",
                letterSpacing: "2px",
              }}
            >
              Enquiry Form
            </Typography>
          </Box>
          <Grid container spacing={2}>
            {/* User Type Selection */}
            <Grid item xs={12}>
              <TextField
                label="User Type"
                variant="outlined"
                select
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
                fullWidth
                size="small"
              >
                <MenuItem value="farmer">Farmer</MenuItem>
                <MenuItem value="employee">Employee</MenuItem>
                <MenuItem value="trader">Trader</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Type"
                variant="outlined"
                select
                value={isNeworOld}
                onChange={(e) => setIsNewOrOld(e.target.value)}
                fullWidth
                size="small"
              >
                <MenuItem value="new">New</MenuItem>
                <MenuItem value="old">Associated</MenuItem>
                <MenuItem value="running">Running</MenuItem>
              </TextField>
            </Grid>

            {(isNeworOld === "old" ||
              isNeworOld === "running" ||
              userType === "employee") && (
              <Grid item xs={12} md={6}>
                <TextField
                  label="Lot Number"
                  variant="outlined"
                  value={lotNumber}
                  onChange={(e) => {
                    setLotNumber(e.target.value);
                  }}
                  fullWidth
                  size="small"
                />
              </Grid>
            )}

            <Grid item xs={12} md={6}>
              <TextField
                label="Name"
                variant="outlined"
                value={farmer_name}
                onChange={(e) => {
                  const value = e.target.value;

                  // Allow only alphabets and spaces using regex
                  if (/^[a-zA-Z\s]*$/.test(value)) {
                    setFarmer_Name(value); // Update state if valid

                    // Clear errors if any
                    if (value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        Farmer_Name: "", // Clear the error
                      }));
                    }
                  }
                }}
                fullWidth
                size="small"
                InputProps={{
                  inputProps: {
                    maxLength: 150, // Limit input length to 10 digits
                  },
                }}
                required
                error={!!errors["Farmer_Name"]}
                helperText={errors["Farmer_Name"] || ""}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Mobile Number"
                variant="outlined"
                value={mobNo}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only numbers (digits) by checking with regex
                  if (/^[0-9]*$/.test(value)) {
                    setMobNo(value);
                  }
                }}
                InputProps={{
                  inputProps: {
                    maxLength: 10, // Limit input length to 10 digits
                  },
                }}
                fullWidth
                size="small"
                required
                error={!!errors["Mobile"]}
                helperText={errors["Mobile"] || ""}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Zone Name"
                variant="outlined"
                value={Zone_Name}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only alphabets, numbers, and spaces
                  if (/^[a-zA-Z0-9\s]*$/.test(value)) {
                    setZone_Name(value);
                  }
                }}
                fullWidth
                size="small"
              />
            </Grid>

            {isNeworOld === "new" && (
              <>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Branch Name"
                    variant="outlined"
                    value={branch_Name}
                    onChange={(e) => setBranch_Name(e.target.value)}
                    fullWidth
                    size="small"
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Shed"
                    name="shed"
                    fullWidth
                    value={shedFeild}
                    onChange={(e) => setShedFeild(e.target.value)}
                    size="small"
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  >
                    <MenuItem
                      value={"Yes"}
                      sx={{
                        borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                        marginBottom: "8px",
                        marginTop: "8px",
                      }}
                    >
                      Yes
                    </MenuItem>
                    <MenuItem
                      value={"No"}
                      sx={{
                        borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                        marginBottom: "8px",
                        marginTop: "8px",
                      }}
                    >
                      No
                    </MenuItem>
                  </TextField>
                </Grid>

                {shedFeild === "Yes" && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Shed Type"
                      variant="outlined"
                      value={Shed_Type}
                      select
                      onChange={(e) => setShed_Type(e.target.value)}
                      fullWidth
                      size="small"
                    >
                      <MenuItem
                        value={"Open"}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        Open
                      </MenuItem>
                      <MenuItem
                        value={"EC"}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        EC
                      </MenuItem>
                    </TextField>
                  </Grid>
                )}

                <Grid item xs={12} md={6}>
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Prev. Poultry Exp."
                    fullWidth
                    value={previousPoultryExperience}
                    onChange={(e) =>
                      setPreviousPoultryExperience(e.target.value)
                    }
                    size="small"
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                    required
                    error={!!errors["previousPoultryExperience"]}
                    helperText={errors["previousPoultryExperience"] || ""}
                  >
                    <MenuItem
                      value={"Yes"}
                      sx={{
                        borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                        marginBottom: "8px",
                        marginTop: "8px",
                      }}
                    >
                      Yes
                    </MenuItem>
                    <MenuItem
                      value={"No"}
                      sx={{
                        borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                        marginBottom: "8px",
                        marginTop: "8px",
                      }}
                    >
                      No
                    </MenuItem>
                  </TextField>
                </Grid>

                {previousPoultryExperience === "Yes" && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Previous Company Name"
                      variant="outlined"
                      value={previousCompanyName}
                      onChange={(e) => setPreviousCompanyName(e.target.value)}
                      fullWidth
                      size="small"
                    />
                  </Grid>
                )}
              </>
            )}

            {isNeworOld === "old" && (
              <>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="First Week Mortality Quantity"
                    variant="outlined"
                    value={first_Week_M}
                    onChange={(e) => setFirst_Week_M(e.target.value)}
                    fullWidth
                    size="small"
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Total Mortality Quantity"
                    variant="outlined"
                    value={Total_Mortality}
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        setTotal_Mortality(e.target.value);
                      }
                    }}
                    fullWidth
                    size="small"
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Average Lifted Weight"
                    variant="outlined"
                    value={Avg_Lift_Wt}
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        setAvg_Lift_Wt(e.target.value);
                      }
                    }}
                    fullWidth
                    size="small"
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Average Body Weight"
                    variant="outlined"
                    value={ABWT}
                    onChange={(e) => {
                      let inputValue = e.target.value;

                      // Allow deletion
                      if (inputValue === "") {
                        setABWT(""); // Allow the input to be empty
                        return;
                      }

                      // Automatically add a decimal point after the first digit if no decimal exists
                      if (/^\d$/.test(inputValue)) {
                        inputValue = inputValue + ".";
                      }

                      // Validate input: numbers with optional decimal and up to 3 decimal places
                      if (/^\d+(\.\d{0,3})?$/.test(inputValue)) {
                        setABWT(inputValue);
                      }
                    }}
                    fullWidth
                    size="small"
                    inputProps={{
                      inputMode: "decimal",
                      pattern: "\\d+(\\.\\d{0,3})?", // Allow up to 3 decimal places
                    }}
                  />
                </Grid>
              </>
            )}

            {isNeworOld === "running" && (
              <>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Chicks Housed"
                    id="outlined-size-small"
                    name="CH"
                    value={chichHoused}
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        setChickHoused(e.target.value);
                      }
                    }}
                    size="small"
                    fullWidth
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Mean Age"
                    id="outlined-size-small"
                    name="AGE"
                    value={meanAge}
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        setMeanAge(e.target.value);
                      }
                    }}
                    size="small"
                    fullWidth
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Body Weight"
                    id="outlined-size-small"
                    name="BWT"
                    value={bodyWeight}
                    onChange={(e) => {
                      if (/^\d?(\.\d{0,3})?$/.test(e.target.value)) {
                        setBodyWeight(e.target.value);
                      }
                    }}
                    size="small"
                    fullWidth
                    inputProps={{
                      inputMode: "decimal",
                      pattern: "\\d?(\\.\\d{0,3})?",
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Total Mortality Quantity"
                    variant="outlined"
                    value={Total_Mortality}
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        setTotal_Mortality(e.target.value);
                      }
                    }}
                    fullWidth
                    size="small"
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Reason"
                    id="outlined-size-small"
                    name="REASON"
                    value={reason}
                    onChange={(e) => {
                      setReason(e.target.value);
                    }}
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiInputLabel-root": {
                        top: "0", // Adjust to align the label properly
                        "&.MuiInputLabel-shrink": {
                          top: "6px", // Ensure the label is fully visible when it shrinks
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Medicine"
                    id="outlined-size-small"
                    name="MED"
                    value={medicine}
                    onChange={(e) => setMedicine(e.target.value)}
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiInputLabel-root": {
                        top: "0", // Adjust to align the label properly
                        "&.MuiInputLabel-shrink": {
                          top: "6px", // Ensure the label is fully visible when it shrinks
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Feed"
                    id="outlined-size-small"
                    name="FEED"
                    value={feed}
                    onChange={(e) => setFeed(e.target.value)}
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Stock"
                    id="outlined-size-small"
                    name="STOCK"
                    value={stock}
                    onChange={(e) => setStock(e.target.value)}
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="IFFT In"
                    id="outlined-size-small"
                    name="IFFT_IN"
                    value={iiftIn}
                    onChange={(e) => setIiftIn(e.target.value)}
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiInputLabel-root": {
                        top: "0", // Adjust to align the label properly
                        "&.MuiInputLabel-shrink": {
                          top: "6px", // Ensure the label is fully visible when it shrinks
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="IFFT Out"
                    id="outlined-size-small"
                    name="IFFT_OUT"
                    value={iiftOut}
                    onChange={(e) => setIiftOut(e.target.value)}
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiInputLabel-root": {
                        top: "0", // Adjust to align the label properly
                        "&.MuiInputLabel-shrink": {
                          top: "6px", // Ensure the label is fully visible when it shrinks
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="LS Visit"
                    id="outlined-size-small"
                    name="LS_VISIT"
                    value={Ls_Visit}
                    onChange={(e) => setLS_Visit(e.target.value)}
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="BM Visit"
                    id="outlined-size-small"
                    name="BM_VISIT"
                    value={Bm_Visit}
                    onChange={(e) => setBM_Visit(e.target.value)}
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Daily Ent"
                    id="outlined-size-small"
                    name="DAILY_ENT"
                    value={Daily_ent}
                    onChange={(e) => setDaily_Ent(e.target.value)}
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Feed Ent"
                    id="outlined-size-small"
                    name="FEED_ENT"
                    value={FeedEnt}
                    onChange={(e) => setFeedEnt(e.target.value)}
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Mortality Ent"
                    id="outlined-size-small"
                    name="MORT_ENT"
                    value={mortality_ent}
                    onChange={(e) => setMortality_Ent(e.target.value)}
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="BWT Ent"
                    id="outlined-size-small"
                    name="BWT_ENT"
                    value={BWT_Ent}
                    onChange={(e) => setBWT_Ent(e.target.value)}
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Medicine Ent"
                    id="outlined-size-small"
                    name="MED_ENT"
                    value={Medicine_ent}
                    onChange={(e) => setMedicine_Ent(e.target.value)}
                    size="small"
                    fullWidth
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} md={6}>
              <TextField
                id="outlined-select-currency"
                select
                label="Status"
                name="status"
                fullWidth
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                size="small"
                sx={{
                  "& .MuiFormHelperText-root": {
                    fontSize: "0.65rem",
                    marginLeft: "0",
                  },
                }}
                required
                error={!!errors["status"]}
                helperText={errors["status"] || ""}
              >
                <MenuItem
                  value={"open"}
                  sx={{
                    borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                    marginBottom: "8px",
                    marginTop: "8px",
                  }}
                >
                  Open
                </MenuItem>
                <MenuItem
                  value={"closed"}
                  sx={{
                    borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                    marginBottom: "8px",
                    marginTop: "8px",
                  }}
                >
                  Closed
                </MenuItem>
              </TextField>
            </Grid>

            {status === "open" && (
              <>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Follow-up Date"
                    type="date"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={
                      follow_up_date
                        ? dayjs(follow_up_date).format("YYYY-MM-DD")
                        : ""
                    }
                    onChange={(e) => {
                      const selectedDate = e.target.value; // Get the value from the event
                      setFollow_Up_Date(selectedDate); // Set the formatted date directly
                      if (selectedDate) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          follow_up_date: "", // Clear the error
                        }));
                      }
                    }}
                    required
                    error={!!errors["follow_up_date"]}
                    helperText={errors["follow_up_date"] || ""}
                    inputProps={{
                      min: dayjs().add(1, "day").format("YYYY-MM-DD"), // Disable today and past dates
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Follow-Up By"
                    variant="outlined"
                    value={followUpBy}
                    inputProps={{
                      maxLength: 250,
                    }}
                    onChange={(e) => setFollowUpBy(e.target.value)}
                    fullWidth
                    size="small"
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <TextField
                label="Remarks"
                id="outlined-size-small"
                name="remarks"
                multiline
                rows={4}
                value={remarks}
                inputProps={{
                  maxLength: 1000,
                }}
                onChange={(e) => {
                  const newRemark = e.target.value.slice(0, 1000); // Trim to 250 characters
                  setRemarks(newRemark);
                  // Remove the error message when the user starts typing
                  if (e.target.value) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      remarks: "", // Clear the error
                    }));
                  }
                  setRemarks(e.target.value);
                }}
                required
                error={!!errors["remarks"]}
                helperText={errors["remarks"] || ""}
                size="small"
                fullWidth
              />
              <Typography
                variant="body2"
                color={remarks.length > 1000 ? "error" : "text.secondary"}
                sx={{ marginLeft: "7px" }}
              >
                {remarks.length}/1000
              </Typography>
            </Grid>
          </Grid>

          {/* Submit Button */}
          <Grid container justifyContent="flex-end" sx={{ marginTop: 2 }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </Button>
          </Grid>
        </Card>
      </form>
    </>
  );
}

export default NewUserAuditFormComponent;
